export const ORDER_SITE_URL = 'https://order.doughmanfoods.com';
